/**
 * useShareStore
 */
import { useCallback } from 'react';

import {
    Queries,
    ApolloLib,
    Mutations,
} from 'bdvp-graphql';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import useModalStore from './useModalStore';

const {
    useMutation,
    useApolloClient,
} = ApolloLib;

const { SHARE_MODAL_NAME } = modalConstants;

const { GET_SHARE_MEDIA_ID } = Queries;

const { SET_SHARE_MEDIA_ID } = Mutations;

const useShareStore = () => {

    const client = useApolloClient();
    const { shareMediaId } = client.readQuery({ query: GET_SHARE_MEDIA_ID });
    const { modalShow } = useModalStore();
    const openShareModal = useCallback(() => modalShow(SHARE_MODAL_NAME), [modalShow]);
    const [setShareMediaId] = useMutation(SET_SHARE_MEDIA_ID, {

        onCompleted: ({ setShareMediaId: shareMediaId }) => {

            if(!shareMediaId) {

                console.error('No share media id found!');
                return;

            }

            openShareModal();

        },

    });

    const _setShareMediaId = useCallback((
        mediaId
    ) => setShareMediaId({
        variables: {
            mediaId,
        },
    }), [setShareMediaId]);

    return {
        shareMediaId,
        shareModalShow: _setShareMediaId,
    };

};

export default useShareStore;
